module.exports = __webpack_public_path__ + "media/images/icons/filled/play-circle-c14aebd36064dccf821bfc3cd8e78ace.svg";